






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MelosMultipleToggle from '@/components/MelosMultipleToggle.vue';

@Component({
  components: {
    MelosMultipleToggle,
  },
})
export default class MelosButtonSet extends Vue {
  @Prop() private labels!: string[];

  private get options(): any[] {
    return this.labels.map((label: string) => ({ label, active: false }));
  }

  private onItemClicked(index: number) {
    this.$emit('click', index);
  }

}

